export default __webpack_public_path__ + "static/media/wb-2.34658b62.webp";